"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1529],{

/***/ 71529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ handleCommonErrors; },
/* harmony export */   "Zy": function() { return /* binding */ useQueryApi; },
/* harmony export */   "fy": function() { return /* binding */ useMutationApi; },
/* harmony export */   "hi": function() { return /* binding */ api; }
/* harmony export */ });
/* unused harmony exports paramsSerializer, refreshSessionWeb, refreshSessionApp, refreshGuruTokenSessionApp, refreshAccessTokenSessionApp */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70655);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68430);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_customError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97512);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84494);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23475);
/* harmony import */ var utils_process__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88265);
/* harmony import */ var configs_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32178);
/* harmony import */ var configs_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13102);















var sessionError = null;
var handleCommonErrors = function(status, path, error) {
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
    if (!androidHandler.enabled && (error === null || error === void 0 ? void 0 : error.message) === "Network Error") {
        throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .NetworkError */ .F7(path, error);
    }
    switch(status){
        case 400:
            throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .InternalServerError */ .Hl(path, error);
        case 401:
            throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .SessionError */ .zM(path, error);
        case 403:
            throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .ForbiddenError */ .lY(path, error);
        case 404:
            throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .NotFoundError */ .dR(path, error);
        case 500:
            throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .InternalServerError */ .Hl(path, error);
        case 503:
            throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .ServiceUnavailableError */ .TC(path, error);
        default:
            throw error;
    }
};
function useQueryApi(path) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        axiosConfig: {},
        queryConfig: {},
        storageKey: configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy,
        storageSerializer: undefined,
        serviceUnavailable: false,
        tokenFromQueryParam: null
    }, _axiosConfig = ref.axiosConfig, axiosConfig = _axiosConfig === void 0 ? {} : _axiosConfig, _queryConfig = ref.queryConfig, queryConfig = _queryConfig === void 0 ? {} : _queryConfig, _storageKey = ref.storageKey, storageKey = _storageKey === void 0 ? configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy : _storageKey, storageSerializer = ref.storageSerializer, _serviceUnavailable = ref.serviceUnavailable, serviceUnavailable = _serviceUnavailable === void 0 ? false : _serviceUnavailable, tokenFromQueryParam = ref.tokenFromQueryParam, _errorHandlerFn = ref.errorHandlerFn, errorHandlerFn = _errorHandlerFn === void 0 ? handleCommonErrors : _errorHandlerFn;
    var queryKey = [];
    if (!!axiosConfig.data) queryKey.push(axiosConfig.data);
    if (!!axiosConfig.params) queryKey.push(axiosConfig.params);
    if (queryKey.length > 0) {
        queryKey = [
            path
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(queryKey));
    } else {
        queryKey = path;
    }
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, function() {
        return api(path, axiosConfig, storageKey, serviceUnavailable, tokenFromQueryParam, storageSerializer, errorHandlerFn);
    }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        useErrorBoundary: true
    }, queryConfig));
}
function useMutationApi(path) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        axiosConfig: {},
        mutationConfig: {},
        storageKey: configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy,
        storageSerializer: undefined,
        tokenFromQueryParam: null
    }, _axiosConfig = ref.axiosConfig, axiosConfig = _axiosConfig === void 0 ? {} : _axiosConfig, _mutationConfig = ref.mutationConfig, mutationConfig = _mutationConfig === void 0 ? {} : _mutationConfig, _storageKey = ref.storageKey, storageKey = _storageKey === void 0 ? configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy : _storageKey, storageSerializer = ref.storageSerializer, tokenFromQueryParam = ref.tokenFromQueryParam, _errorHandlerFn = ref.errorHandlerFn, errorHandlerFn = _errorHandlerFn === void 0 ? handleCommonErrors : _errorHandlerFn;
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function(data) {
        var pathApi = typeof path === "function" ? path(data) : path;
        return api(pathApi, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, axiosConfig), {
            data: data
        }), storageKey, false, tokenFromQueryParam, storageSerializer, errorHandlerFn);
    }, mutationConfig);
}
var paramsSerializer = function(params) {
    return (0,query_string__WEBPACK_IMPORTED_MODULE_1__/* .stringify */ .Pz)(params !== null && params !== void 0 ? params : {}, {
        arrayFormat: "none"
    });
};
var guruTokenShallowValidation = function(storageSerializer, storageKey, path) {
    // only allow non empty token for now since there are user that use old version of apps
    // return !!token && token.indexOf('guru') === 0
    var session = storageSerializer((0,utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .getSession */ .Gg)(storageKey));
    // check if current session is using guru token and guru token is not empty and has guru prefix
    // if (
    //   session.hasOwnProperty('guruToken') &&
    //   (!session.guruToken || session.guruToken.indexOf('guru') !== 0)
    // ) {
    //   throw new SessionError(path, null)
    // }
    if (session.hasOwnProperty("guruToken") && !session.guruToken) {
        throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .SessionError */ .zM(path, null);
    }
};
function api(path) {
    return _api.apply(this, arguments);
}
function _api() {
    _api = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(path) {
        var options, storageKey, serviceUnavailable, tokenFromQueryParam, storageSerializer, errorHandlerFn, androidHandler, requestApi, refreshSession, response, error, ref, pathname, status;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, storageKey = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy, serviceUnavailable = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false, tokenFromQueryParam = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : undefined, storageSerializer = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : function(param) {
                        return param;
                    }, errorHandlerFn = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : handleCommonErrors;
                    androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
                    requestApi = function() {
                        var url = "".concat(configs_api__WEBPACK_IMPORTED_MODULE_5__/* .baseUrl */ .F).concat(path);
                        if (tokenFromQueryParam) {
                            options.headers = {
                                Authorization: "Bearer ".concat(tokenFromQueryParam)
                            };
                        } else {
                            var session = storageSerializer((0,utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .getSession */ .Gg)(storageKey));
                            options.headers = {
                                Authorization: "Bearer ".concat(session.guruToken || session.accessToken)
                            };
                        }
                        return axios__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            paramsSerializer: paramsSerializer,
                            url: url
                        }, options));
                    };
                    if (serviceUnavailable) {
                        throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .ServiceUnavailableError */ .TC(path, null);
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    if (!!tokenFromQueryParam) return [
                        3,
                        3
                    ];
                    refreshSession = androidHandler.enabled ? refreshSessionApp : refreshSessionWeb;
                    return [
                        4,
                        refreshSession(storageKey, storageSerializer)
                    ];
                case 2:
                    _state.sent();
                    guruTokenShallowValidation(storageSerializer, storageKey, path);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        requestApi()
                    ];
                case 4:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 5:
                    error = _state.sent();
                    // eslint-disable-next-line
                    console.log("api-error: ".concat(path), JSON.stringify(error === null || error === void 0 ? void 0 : error.response));
                    // Force logout when session expired / un-refresh-able
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(error, utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .SessionError */ .zM) && !sessionError) {
                        sessionError = error;
                        if (androidHandler.enabled) {
                            androidHandler.requestLogin();
                        } else {
                            pathname = window.location.pathname || "/home";
                            window.location.href = "/logout?from=".concat(pathname, "&target=/login&error=SessionError");
                        }
                    }
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(error, utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .CustomError */ .sH)) {
                        throw error;
                    }
                    status = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status;
                    errorHandlerFn(status, path, error, error.response);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _api.apply(this, arguments);
}
var refreshTokenPromise;
function refreshSessionWeb(storageKey) {
    return _refreshSessionWeb.apply(this, arguments);
}
function _refreshSessionWeb() {
    _refreshSessionWeb = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(storageKey) {
        var storageSerializer, session, isGuruToken, expiryTime, sessionExpiryTime, currentTime, isTokenExpired, path, apiUrl, data, guruTokenAxiosConfig, accessTokenAxiosConfig, axiosConfig, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    storageSerializer = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : function(param) {
                        return param;
                    };
                    session = storageSerializer((0,utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .getSession */ .Gg)(storageKey));
                    isGuruToken = !!session.guruToken;
                    expiryTime = isGuruToken ? session.expiredAt : session.expiryToken;
                    sessionExpiryTime = new Date(expiryTime).getTime();
                    currentTime = new Date().getTime();
                    isTokenExpired = sessionExpiryTime < currentTime;
                    path = isGuruToken ? "/teachers/v1alpha2/guru-token/refresh" : "/teachers/v1alpha1/profile/refresh_token";
                    guruTokenShallowValidation(storageSerializer, storageKey, null);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    if (!isTokenExpired) return [
                        3,
                        3
                    ];
                    apiUrl = configs_api__WEBPACK_IMPORTED_MODULE_5__/* .baseUrl */ .F + path;
                    if (!refreshTokenPromise) {
                        guruTokenAxiosConfig = {
                            url: apiUrl,
                            method: "POST",
                            headers: {
                                Authorization: "Bearer ".concat(session.guruToken)
                            }
                        };
                        accessTokenAxiosConfig = {
                            url: (0,utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .setAuthToAPI */ .Y9)(apiUrl, session),
                            method: "GET"
                        };
                        axiosConfig = isGuruToken ? guruTokenAxiosConfig : accessTokenAxiosConfig;
                        refreshTokenPromise = axios__WEBPACK_IMPORTED_MODULE_2___default()(axiosConfig);
                    }
                    return [
                        4,
                        refreshTokenPromise
                    ];
                case 2:
                    data = _state.sent().data;
                    data = data.data || data;
                    window.localStorage.setItem(storageKey, JSON.stringify(data));
                    refreshTokenPromise = null;
                    return [
                        2,
                        data
                    ];
                case 3:
                    return [
                        2,
                        session
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    error = _state.sent();
                    refreshTokenPromise = null;
                    throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .SessionError */ .zM(path, error);
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _refreshSessionWeb.apply(this, arguments);
}
function refreshSessionApp(storageKey) {
    return _refreshSessionApp.apply(this, arguments);
}
function _refreshSessionApp() {
    _refreshSessionApp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(storageKey) {
        var storageSerializer, androidHandler;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            storageSerializer = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : function(param) {
                return param;
            };
            androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
            return [
                2,
                androidHandler.guruTokenEnabled ? refreshGuruTokenSessionApp(storageKey, storageSerializer) : refreshAccessTokenSessionApp(storageKey, storageSerializer)
            ];
        });
    });
    return _refreshSessionApp.apply(this, arguments);
}
var refreshAppSessionPromise;
function refreshGuruTokenSessionApp(storageKey) {
    return _refreshGuruTokenSessionApp.apply(this, arguments);
}
function _refreshGuruTokenSessionApp() {
    _refreshGuruTokenSessionApp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(storageKey) {
        var storageSerializer, session, sessionExpiryTime, currentTime, isTokenExpired, androidHandler, data, newSession, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    storageSerializer = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : function(param) {
                        return param;
                    };
                    session = storageSerializer((0,utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .getSession */ .Gg)(storageKey));
                    sessionExpiryTime = new Date(session.expiredAt).getTime();
                    currentTime = new Date().getTime();
                    isTokenExpired = sessionExpiryTime < currentTime;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    if (!isTokenExpired) return [
                        3,
                        3
                    ];
                    androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
                    if (!refreshAppSessionPromise) {
                        refreshAppSessionPromise = androidHandler.getAuthData(true);
                    }
                    return [
                        4,
                        refreshAppSessionPromise
                    ];
                case 2:
                    data = _state.sent();
                    newSession = {
                        accessToken: "",
                        tokenType: "Bearer",
                        expiryToken: data.expiredAt,
                        refreshToken: "",
                        email: data.user.email,
                        expiredAt: data.expiredAt,
                        guruToken: data.guruToken,
                        user: data.user
                    };
                    window.localStorage.setItem(configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy, JSON.stringify(newSession));
                    return [
                        2,
                        newSession
                    ];
                case 3:
                    return [
                        2,
                        session
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    error = _state.sent();
                    refreshAppSessionPromise = null;
                    throw new utils_customError__WEBPACK_IMPORTED_MODULE_7__/* .SessionError */ .zM("app-refresh-session-error", error);
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _refreshGuruTokenSessionApp.apply(this, arguments);
}
function refreshAccessTokenSessionApp(storageKey) {
    return _refreshAccessTokenSessionApp.apply(this, arguments);
}
function _refreshAccessTokenSessionApp() {
    _refreshAccessTokenSessionApp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(storageKey) {
        var storageSerializer, session, sessionExpiryTime, currentTime, isTokenExpired, androidHandler, accessToken, expiredAt, user, newSession;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    storageSerializer = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : function(param) {
                        return param;
                    };
                    session = storageSerializer((0,utils_auth__WEBPACK_IMPORTED_MODULE_3__/* .getSession */ .Gg)(storageKey));
                    sessionExpiryTime = new Date(session.expiryToken).getTime();
                    currentTime = new Date().getTime();
                    isTokenExpired = sessionExpiryTime < currentTime;
                    if (!isTokenExpired) return [
                        3,
                        2
                    ];
                    androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
                    androidHandler.refreshToken();
                    return [
                        4,
                        (0,utils_process__WEBPACK_IMPORTED_MODULE_14__/* .timeout */ .V)(1000)
                    ];
                case 1:
                    _state.sent();
                    accessToken = androidHandler.requestAccessToken();
                    expiredAt = new Date(new Date().getTime() + 3600 * 1000).toISOString();
                    user = JSON.parse(androidHandler.getUser());
                    newSession = {
                        accessToken: accessToken,
                        tokenType: "Bearer",
                        expiryToken: expiredAt,
                        refreshToken: "dummy-refresh-token",
                        email: androidHandler.getEmail(),
                        expiredAt: expiredAt,
                        guruToken: "",
                        user: {
                            id: user.id,
                            name: user.name,
                            email: user.email,
                            picture: user.photoUrl,
                            groups: user.groups
                        }
                    };
                    window.localStorage.setItem(configs_auth__WEBPACK_IMPORTED_MODULE_4__/* .APP_LOGIN_STORAGE_KEY */ .zy, JSON.stringify(newSession));
                    return [
                        2,
                        newSession
                    ];
                case 2:
                    return [
                        2,
                        session
                    ];
            }
        });
    });
    return _refreshAccessTokenSessionApp.apply(this, arguments);
}


/***/ })

}]);